export default class ProductRelatedController {
  /* @ngInject */
  constructor($translate, RouterService, ProductService, BreadcrumbService, MediaQueryService, CommunicationToolService, RelatedModel, PRODUCT_CONSTANT) {
    this.routerService = RouterService;
    this.productService = ProductService;
    this.communicationToolService = CommunicationToolService;
    this.RelatedModel = RelatedModel;
    this.mediaQueryService = MediaQueryService;
    this.translate = $translate;
    this.breadcrumbService = BreadcrumbService;
    this.PRODUCT_CONSTANT = PRODUCT_CONSTANT;
    this.onBreadcrumbClick = this.onBreadcrumbClick.bind(this);
  }

  $onInit() {
    const {RELATED} = this.PRODUCT_CONSTANT;
    const {id, type} = this.routerService.state.params;
    this.isRelatedVariations = type === RELATED.VARIATIONS;
    this.isRelatedCommunicationTools = type === RELATED.COMMUNICATION_TOOLS;
    this.listenMediaQuery();
    this.productService.get(id)
      .then((product) => {
        this.breadcrumbs = [
          {id: product.genderId, value: product.gender, filter: 'gender'},
          {id: product.categoryId, value: product.category, filter: 'category'},
          {id: product.typeId, value: product.type, filter: 'type'},
        ];
        return this.productService.variations(id);
      })
      .then((variations) => {
        this.isRelatedVariations && this.bindRelatedModel(variations);
      });

    if (this.isRelatedCommunicationTools) {
      this.communicationToolService.relatedToProduct(id).then(data => this.bindRelatedModel(data));
    }
  }

  bindRelatedModel(newData) {
    this.relatedList = newData.map(i => new this.RelatedModel(i));
    const currentView = this.isRelatedVariations ? this.translate.instant('PRODUCT.PRODUCT_VARIATIONS') : this.translate.instant('EDITORIAL.EDITORIALS');
    this.breadcrumbs = [...this.breadcrumbs, {label: currentView}];
  }

  goTo({id, category, gender, collection, isProduct}) {
    if (isProduct) {
      this.routerService.state.go('product', {id, gender: gender.value.toLowerCase()});
      return;
    }
    this.routerService.state.go('communicationToolDetail', {
      categoryId: category.id,
      collectionId: collection.id,
      itemId: id,
    });
  }

  listenMediaQuery() {
    this.isTablet = this.mediaQueryService.is('tablet');
    this.mediaQueryService.on('tablet', match => this.isTablet = match);
    this.isDesktop = this.mediaQueryService.is('desktop');
    this.mediaQueryService.on('desktop', match => this.isDesktop = match);
  }

  onBreadcrumbClick(items, item) {
    const params = this.breadcrumbService.createFilterParams(items, item);
    this.routerService.state.go('products', params);
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-related/product-related.controller.js